<app-loadable-content [loadingController]="businessLoadingController" (onRetry)="loadBusiness()">
    <app-title>{{ headerText }}</app-title>
</app-loadable-content>
